<template>
  <div>
    <v-snackbar top :color="snackbarColor" :timeout="3000" absolute v-model="snackbar">{{ snackbarText }}</v-snackbar>
    <v-card>
      <v-card-title>
        <h2>Nuevo mandado </h2>
        <v-btn style="right: 10px" icon color="primary" fab absolute @click="$emit('cancel')">
          <v-icon dark style="font-size: 20px">fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container fluid>
          <div class="main-item" v-for="(item, index) of typesOfErrand" :key="index" @click="nextTo('to', item)">
            <div class="icon">
              <i :class="item.icon"></i>
            </div>
            <div class="item-details">
              <h2 class="font-weight-bold">{{ item.name }}</h2>
              <p class="mt-3" style="text-align: justify">
                {{ item.description }}
              </p>
            </div>
          </div>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" max-width="650">
      <v-card>
        <v-card-title class="red--text font-weight-bold justify-center">Fuera de horario</v-card-title>
        <v-card-text v-if="isDayActive && !showEndOfDayMsg">El servicio no está disponible en ese momento. El horario habilitado para el día de hoy es:</v-card-text>
        <v-card-text v-if="!isDayActive" class="text-center font-weight-bold">
          <v-icon color="error" class="mr-2">mdi-block-helper</v-icon>
          El servicio no está disponible hoy.
          <span v-if="nextEnabledDayLabel">
            Estará disponible nuevamente {{ nextEnabledDayLabel }}
          </span>
          <span v-else>
            No hay horarios configurados para este negocio.
          </span>
        </v-card-text>
        <v-card-text v-if="showEndOfDayMsg" class="text-center font-weight-bold">
          El servicio ha finalizado por hoy.
          <span v-if="todaySchedule && todaySchedule.length && nextEnabledDay">
            Estará disponible nuevamente{{ nextEnabledDayLabel }}.
          </span>
          <span v-else>
            No hay horarios configurados para este negocio.
          </span>
        </v-card-text>
        <v-card-text v-if="isDayActive && !showEndOfDayMsg" class="justify-center">
          <v-data-table :headers="[
              { text: 'De:', value: 'opensAt',},
              { text: 'A:', value: 'closesAt', }
            ]" 
            :items="todaySchedule"  
            disable-pagination
            hide-default-footer>
            <template v-slot:top>
              <div v-if="!todaySchedule.length">Horario no disponible para el día de hoy.</div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/firebase";
import { isWithinSchedule } from "../utils/validations";

function formatToAMPM(timeStr) {
  if (!timeStr) return "--:--";
  const [hour, minute] = timeStr.slice(0, 5).split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${String(minute).padStart(2, "0")} ${period}`;
}

export default {
  name: "details-dialog",
  props: ["waypoints", "routeData", "buttonText", "paymentData"],
  data() {
    return {
      typesOfErrand: this.getTypesOfErrand(),
      todaySchedule: [],
      isActive: false,
      dialog: false,
      isDayActive: false,
      snackbar: "",
      snackbarText: "",
      snackbarColor: "red darken-2",
      schedule: [],
      lastCloseTime: null,
      showEndOfDayMsg: false,
      nextEnabledDay: null,
      nextEnabledDayLabel: null
    };
  },
  mounted() {
    this.getSchedule();
    // Suscribirse a cambios en tiempo real del negocio
    this.unsubscribe = db.collection("businessesCorporative")
      .doc(this.user.businessID)
      .onSnapshot((doc) => {
        if (doc.exists) {
          this.schedule = doc.data().schedule;
          this.processSchedule();
        }
      });
  },
  beforeDestroy() {
    // Cancelar la suscripción al desmontar el componente
    if (this.unsubscribe) this.unsubscribe();
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    getTypesOfErrand() {
      return [
        {
          name: "Mandado + Link de Pago",
          icon: "fas fa-link",
          to: "/payment-link",
          needPermission: true,
          permissionFlag: "allowPayLinks",
          description:
            "Genera un link de pago para compartilo con tus clientes. Cuando se realice el pago se asignará la tarea a un motorista para ir a entregar el producto.",
        },
        {
          name: "Mandado Solo",
          icon: "fas fa-route",
          needPermission: false,
          to: "/map",
          description:
            "Crea la ruta y define las instrucciones para el mandado que necesitas.",
        },
      ];
    },
    async getSchedule() {
      try {
        const businessData = await this.$binding(
          "business",
          db.collection("businessesCorporative").doc(this.user.businessID)
        );
        this.schedule = businessData.schedule;
        this.processSchedule();
      } catch (error) {
        console.error("Error fetching schedule:", error);
      }
    },
    processSchedule() {
      if (!this.schedule) {
        this.isActive = false;
        this.isDayActive = false;
        this.showEndOfDayMsg = false;
        this.nextEnabledDay = null;
        this.nextEnabledDayLabel = null;
        return;
      }
      const currentDay = new Date().toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
      const capitalizedDay = currentDay.charAt(0).toUpperCase() + currentDay.slice(1);
      this.isDayActive = this.schedule[`active${capitalizedDay}`];
      const today = this.schedule[currentDay] || [];
      // Calcular la última hora de cierre
      let lastClose = null;
      if (today.length > 0) {
        lastClose = today.reduce((max, slot) => slot.closesAt > max ? slot.closesAt : max, today[0].closesAt);
      }
      this.lastCloseTime = lastClose;
      this.todaySchedule = today
        .sort((a, b) => a.opensAt.localeCompare(b.opensAt))
        .map(slot => ({
          opensAt: formatToAMPM(slot.opensAt),
          closesAt: formatToAMPM(slot.closesAt),
        }));
      // Verificar si la hora actual es mayor a la última hora de cierre
      let now = new Date();
      let nowStr = now.toTimeString().slice(0,5);
      this.showEndOfDayMsg = false;
      if (lastClose && this.isDayActive) {
        this.showEndOfDayMsg = nowStr > lastClose;
      }
      this.isActive = this.isDayActive && isWithinSchedule(this.todaySchedule);

      // Calcular el próximo día habilitado
      const daysOfWeekEn = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
      const daysOfWeekEs = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
      const todayIndex = new Date().getDay();
      this.nextEnabledDay = null;
      this.nextEnabledDayLabel = null;
      for (let i = 1; i <= 7; i++) {
        const nextDayIndex = (todayIndex + i) % 7;
        const nextDayEn = daysOfWeekEn[nextDayIndex];
        const nextDayEs = daysOfWeekEs[nextDayIndex];
        if (this.schedule[`active${nextDayEn.charAt(0).toUpperCase() + nextDayEn.slice(1)}`]) {
          this.nextEnabledDay = nextDayEs;
          // Si es el día siguiente
          if (i === 1) {
            this.nextEnabledDayLabel = ' mañana';
          } else {
            this.nextEnabledDayLabel = ' el día ' + nextDayEs.charAt(0).toLowerCase() + nextDayEs.slice(1);
          }
          break;
        }
      }
    },
    nextTo(to, item) {
      // Siempre verifica el horario actualizado antes de continuar
      this.processSchedule();
      if (!this.isActive) {
        this.dialog = true;
      } else {
        this.$emit(to, item);
      }
    },
  },
};
</script>

<style lang="scss">
.title{
  color: #FF1744;
}
.main-item {
  display: grid;
  grid-template-columns: 20% 80%;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 10px;
  cursor: pointer;
  // margin: 20px 10px;

  &:hover {
    background-color: #f069250f;
  }
}

@media (orientation: landscape) {
  .main-item {
    margin: 0;
  }
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    font-size: 40px;
    color: #FF1744;
  }
  .custom-header thead th{
    font-weight: bold !important;
  }
}
</style>